/* ===========================================================
   HARVEYS WOODWORX
   BESPOKE PRODUCTS DATABASE
   Version 1.0
=========================================================== */


const bespokeProducts = {


Furniture: {


    "Dining Table": {

        icon:"🍽️",

        description:"Beautiful handcrafted solid timber dining tables.",

        dimensions:[

            {
                id:"length",
                label:"Table Length",
                icon:"📏",
                placeholder:"Example: 1800"
            },

            {
                id:"width",
                label:"Table Width",
                icon:"↔️",
                placeholder:"Example: 900"
            },

            {
                id:"height",
                label:"Table Height",
                icon:"⬆️",
                placeholder:"Example: 750"
            },

            {
                id:"thickness",
                label:"Tabletop Thickness",
                icon:"🪵",
                placeholder:"Example: 40"
            }

        ]

    },





    "Coffee Table": {

        icon:"☕",

        description:"Modern handcrafted coffee tables.",

        dimensions:[

            {
                id:"length",
                label:"Table Length",
                icon:"📏",
                placeholder:"Example: 1200"
            },

            {
                id:"width",
                label:"Table Width",
                icon:"↔️",
                placeholder:"Example: 600"
            },

            {
                id:"height",
                label:"Table Height",
                icon:"⬆️",
                placeholder:"Example: 450"
            },

            {
                id:"thickness",
                label:"Top Thickness",
                icon:"🪵",
                placeholder:"Example: 35"
            }

        ]

    },





    "Desk": {

        icon:"💻",

        description:"Custom home office and executive desks.",

        dimensions:[

            {
                id:"length",
                label:"Desk Length",
                icon:"📏",
                placeholder:"Example: 1600"
            },

            {
                id:"depth",
                label:"Desk Depth",
                icon:"↔️",
                placeholder:"Example: 700"
            },

            {
                id:"height",
                label:"Desk Height",
                icon:"⬆️",
                placeholder:"Example: 750"
            },

            {
                id:"thickness",
                label:"Desktop Thickness",
                icon:"🪵",
                placeholder:"Example: 30"
            }

        ]

    },





    "TV Unit": {

        icon:"📺",

        description:"Custom entertainment units.",

        dimensions:[

            {
                id:"length",
                label:"Unit Length",
                icon:"📏",
                placeholder:"Example: 1800"
            },

            {
                id:"height",
                label:"Unit Height",
                icon:"⬆️",
                placeholder:"Example: 600"
            },

            {
                id:"depth",
                label:"Unit Depth",
                icon:"↔️",
                placeholder:"Example: 400"
            }

        ]

    },





    "Cabinet": {

        icon:"🗄️",

        description:"Storage cabinets built to your requirements.",

        dimensions:[

            {
                id:"width",
                label:"Cabinet Width",
                icon:"📏",
                placeholder:"Example: 900"
            },

            {
                id:"height",
                label:"Cabinet Height",
                icon:"⬆️",
                placeholder:"Example: 2000"
            },

            {
                id:"depth",
                label:"Cabinet Depth",
                icon:"↔️",
                placeholder:"Example: 450"
            }

        ]

    },





    "Bench": {

        icon:"🪑",

        description:"Indoor and outdoor timber benches.",

        dimensions:[

            {
                id:"length",
                label:"Bench Length",
                icon:"📏",
                placeholder:"Example: 1500"
            },

            {
                id:"depth",
                label:"Bench Depth",
                icon:"↔️",
                placeholder:"Example: 400"
            },

            {
                id:"height",
                label:"Seat Height",
                icon:"⬆️",
                placeholder:"Example:450"
            }

        ]

    },





    "Bedside Table": {

        icon:"🛏️",

        description:"Matching bedside furniture.",

        dimensions:[

            {
                id:"width",
                label:"Width",
                icon:"📏",
                placeholder:"Example:500"
            },

            {
                id:"depth",
                label:"Depth",
                icon:"↔️",
                placeholder:"Example:400"
            },

            {
                id:"height",
                label:"Height",
                icon:"⬆️",
                placeholder:"Example:600"
            }

        ]

    }


},


/* ===========================================================
   SHELVING
=========================================================== */

Shelving: {


    "Floating Shelves": {

        icon:"🪵",

        description:
        "Minimal handcrafted floating shelves designed around your space.",

        dimensions:[

            {
                id:"length",
                label:"Shelf Length",
                icon:"📏",
                placeholder:"Example:1200"
            },

            {
                id:"depth",
                label:"Shelf Depth",
                icon:"↔️",
                placeholder:"Example:250"
            },

            {
                id:"thickness",
                label:"Shelf Thickness",
                icon:"🪵",
                placeholder:"Example:40"
            }

        ]

    },


    "Wall Mounted Shelving": {

        icon:"📚",

        description:
        "Custom shelving systems for storage, display and organisation.",

        dimensions:[

            {
                id:"width",
                label:"Overall Width",
                icon:"📏",
                placeholder:"Example:2000"
            },

            {
                id:"height",
                label:"Overall Height",
                icon:"⬆️",
                placeholder:"Example:1800"
            },

            {
                id:"depth",
                label:"Shelf Depth",
                icon:"↔️",
                placeholder:"Example:350"
            }

        ]

    },


    "Bookcase": {

        icon:"📖",

        description:
        "Custom timber bookcases built to suit your home.",

        dimensions:[

            {
                id:"width",
                label:"Width",
                icon:"📏",
                placeholder:"Example:1200"
            },

            {
                id:"height",
                label:"Height",
                icon:"⬆️",
                placeholder:"Example:2000"
            },

            {
                id:"depth",
                label:"Depth",
                icon:"↔️",
                placeholder:"Example:350"
            }

        ]

    },


    "Custom Storage Shelving": {

        icon:"🗄️",

        description:
        "Bespoke shelving designed for your exact storage requirements.",

        dimensions:[

            {
                id:"width",
                label:"Width",
                icon:"📏",
                placeholder:"Example:2000"
            },

            {
                id:"height",
                label:"Height",
                icon:"⬆️",
                placeholder:"Example:2200"
            },

            {
                id:"depth",
                label:"Depth",
                icon:"↔️",
                placeholder:"Example:450"
            }

        ]

    }


},


/* ===========================================================
   LIGHTING
=========================================================== */

Lighting: {


    "Pendant Light": {

        icon:"💡",

        description:
        "Unique handcrafted timber pendant lighting for dining areas and feature spaces.",

        dimensions:[

            {
                id:"diameter",
                label:"Shade Diameter",
                icon:"⭕",
                placeholder:"Example:400"
            },

            {
                id:"height",
                label:"Overall Height",
                icon:"⬆️",
                placeholder:"Example:600"
            }

        ]

    },


    "Standing Lamp": {

        icon:"🛋️",

        description:
        "Statement timber floor lamps designed to add warmth and character to your home.",

        dimensions:[

            {
                id:"height",
                label:"Lamp Height",
                icon:"⬆️",
                placeholder:"Example:1500"
            },

            {
                id:"width",
                label:"Lamp Width",
                icon:"↔️",
                placeholder:"Example:400"
            },

            {
                id:"shade",
                label:"Shade Diameter",
                icon:"⭕",
                placeholder:"Example:350"
            }

        ]

    },


    "Table Lamp": {

        icon:"🪔",

        description:
        "Handcrafted timber table lamps for bedside tables, offices and living spaces.",

        dimensions:[

            {
                id:"height",
                label:"Lamp Height",
                icon:"⬆️",
                placeholder:"Example:500"
            },

            {
                id:"width",
                label:"Lamp Width",
                icon:"↔️",
                placeholder:"Example:200"
            }

        ]

    },


    "Wall Light": {

        icon:"🌙",

        description:
        "Custom timber wall lighting features for unique interior spaces.",

        dimensions:[

            {
                id:"height",
                label:"Light Height",
                icon:"⬆️",
                placeholder:"Example:500"
            },

            {
                id:"width",
                label:"Light Width",
                icon:"↔️",
                placeholder:"Example:250"
            },

            {
                id:"depth",
                label:"Projection Depth",
                icon:"↔️",
                placeholder:"Example:120"
            }

        ]

    },


    "Custom Lighting Feature": {

        icon:"✨",

        description:
        "A completely unique lighting concept designed around your vision.",

        dimensions:[

            {
                id:"length",
                label:"Overall Length",
                icon:"📏",
                placeholder:"Example:1200"
            },

            {
                id:"width",
                label:"Overall Width",
                icon:"↔️",
                placeholder:"Example:400"
            },

            {
                id:"height",
                label:"Overall Height",
                icon:"⬆️",
                placeholder:"Example:800"
            }

        ]

    }


},


/* ===========================================================
   OUTDOOR
=========================================================== */

Outdoor: {


"Patio Dining Set": {

    icon:"🌿",

    description:
    "Handcrafted outdoor dining sets including timber tables and matching seating.",

    dimensions:[

        {
            id:"tableLength",
            label:"Table Length",
            icon:"📏",
            placeholder:"Example:2000"
        },

        {
            id:"tableWidth",
            label:"Table Width",
            icon:"↔️",
            placeholder:"Example:1000"
        },

        {
            id:"tableHeight",
            label:"Table Height",
            icon:"⬆️",
            placeholder:"Example:750"
        },

        {
            id:"chairCount",
            label:"Number of Chairs",
            icon:"🪑",
            placeholder:"Example:6"
        }

    ]

},


    "Outdoor Bench": {

        icon:"🪑",

        description:
        "Solid timber outdoor benches designed for gardens and patios.",

        dimensions:[

            {
                id:"length",
                label:"Bench Length",
                icon:"📏",
                placeholder:"Example:1800"
            },

            {
                id:"depth",
                label:"Bench Depth",
                icon:"↔️",
                placeholder:"Example:450"
            },

            {
                id:"height",
                label:"Seat Height",
                icon:"⬆️",
                placeholder:"Example:450"
            }

        ]

    },


    "Outdoor Lounge Set": {

        icon:"🏡",

        description:
        "Custom outdoor seating solutions for patios and entertainment areas.",

        dimensions:[

            {
                id:"length",
                label:"Overall Length",
                icon:"📏",
                placeholder:"Example:2500"
            },

            {
                id:"depth",
                label:"Overall Depth",
                icon:"↔️",
                placeholder:"Example:800"
            },

            {
                id:"height",
                label:"Seat Height",
                icon:"⬆️",
                placeholder:"Example:450"
            }

        ]

    },


    "Planter Boxes": {

        icon:"🌱",

        description:
        "Custom timber planter boxes for outdoor spaces.",

        dimensions:[

            {
                id:"length",
                label:"Length",
                icon:"📏",
                placeholder:"Example:1000"
            },

            {
                id:"width",
                label:"Width",
                icon:"↔️",
                placeholder:"Example:400"
            },

            {
                id:"height",
                label:"Height",
                icon:"⬆️",
                placeholder:"Example:500"
            }

        ]

    }


},





/* ===========================================================
   OTHER
=========================================================== */

Other: {


    "Custom Project": {

        icon:"🛠️",

        description:
        "Have another idea? Tell us what you would like created.",

        dimensions:[

            {
                id:"length",
                label:"Approximate Length",
                icon:"📏",
                placeholder:"Example:1000"
            },

            {
                id:"width",
                label:"Approximate Width",
                icon:"↔️",
                placeholder:"Example:500"
            },

            {
                id:"height",
                label:"Approximate Height",
                icon:"⬆️",
                placeholder:"Example:700"
            }

        ]

    }


}


};
